import * as React from "react";
import { cn } from "@/utils/cn";

interface SliderProps {
	className?: string;
	value?: number[];
	onValueChange?: (value: number[]) => void;
	min?: number;
	max?: number;
	step?: number;
	disabled?: boolean;
}

const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
	({ className, value = [0], onValueChange, min = 0, max = 100, step = 1, disabled }, ref) => {
		const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
			const newValue = Number(event.target.value);
			onValueChange?.([newValue]);
		};

		const percentage = ((value[0] - min) / (max - min)) * 100;

		return (
			<div className={cn("relative flex w-full touch-none select-none items-center", className)}>
				<div className="relative h-2 w-full grow overflow-hidden rounded-full bg-gray-200">
					<div
						className="absolute h-full bg-blue-600 rounded-full"
						style={{ width: `${percentage}%` }}
					/>
				</div>
				<input
					type="range"
					ref={ref}
					className="absolute w-full h-2 opacity-0 cursor-pointer disabled:cursor-not-allowed"
					value={value[0]}
					onChange={handleChange}
					min={min}
					max={max}
					step={step}
					disabled={disabled}
				/>
				<div
					className={cn(
						"absolute h-5 w-5 rounded-full border-2 border-blue-600 bg-white shadow-md transition-transform",
						disabled && "opacity-50 cursor-not-allowed"
					)}
					style={{ left: `calc(${percentage}% - 10px)` }}
				/>
			</div>
		);
	},
);
Slider.displayName = "Slider";

export { Slider };
